import React from 'react';
import { FaGithub, FaLinkedin, FaInstagram, FaEnvelope } from 'react-icons/fa';

const Home = () => {
  return (
    <section id="home" className="relative flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl sm:text-6xl font-bold text-gray-900 mb-6 animate-fadeIn">
          <span className="text-primary">Imran Melikov</span>
        </h1>
        <p className="text-xl sm:text-2xl text-gray-700 mb-12 animate-fadeIn">
          Providing professional IT services. Taking your business to the next level with modern and innovative solutions.
        </p>
        
        <div className="flex justify-center space-x-8 animate-fadeIn">
          <a
            href="mailto:imran.melikov84@gmail.com"
            className="text-gray-600 hover:text-red-500 transition-colors duration-300 transform hover:scale-110"
            title="Email"
          >
            <FaEnvelope size={28} />
          </a>
          <a
            href="https://linkedin.com/in/imran-melikov"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-[#0077b5] transition-colors duration-300 transform hover:scale-110"
            title="LinkedIn"
          >
            <FaLinkedin size={28} />
          </a>
          <a
            href="https://github.com/imranmelikov0"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-[#333] transition-colors duration-300 transform hover:scale-110"
            title="GitHub"
          >
            <FaGithub size={28} />
          </a>
          <a
            href="https://instagram.com/imranmelikov225"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-[#E4405F] transition-colors duration-300 transform hover:scale-110"
            title="Instagram"
          >
            <FaInstagram size={28} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home; 